import { XCircle } from "@phosphor-icons/react"
import React from "react"
import Loader from "../Loaders/buttonLoader"

const Modal = ({
  handleClose,
  handleModalSubmit,
  handleOnclick,
  handleModalSubmit2,
  handleResentCashPin,
  Title,
  Content,
  ButtonText,
  ButtonText2,
  bigModal,
  loader
}) => (
  <div className="bg-surface_overlay backdrop-blur-2xl text-body fixed top-0 left-0 w-full h-full overflow-auto pt-[50px] z-40">
    <div className={`flex flex-col-reverse md:flex-row ${bigModal ? "max-w-5xl":"max-w-[38rem]"} mx-auto`}>
      <div className="flex-grow bg-white md:w-1/2 border border-border_lighter p-8 rounded-md mx-4">
      <div className={`flex justify-between items-center`}>
        <div />
        {!!Title && (<div className=" text-heading_sm font-bold text-body pl-6">{Title}</div>)}
      <div className="fill-brand w-8 hover:fill-red_600 cursor-pointer">
        <a href={() => false} onClick={handleClose}>
        <XCircle weight="fill" color="" size="100%" />
        </a>
      </div>
      </div>
        <div className="">
          {Content}
        </div>
        <div className="flex flex-col items-center gap-2 mt-7">
          {!!ButtonText && (
            <div className={`w-full bg-brand text-negative text-subtitle rounded-full py-4 hover:bg-red_600 ${
              loader === true ? "bg-disabled" : "tracking-wider "
            }`}>
              <a
                aria-label="submit"
                type="submit"
                href={handleModalSubmit}
                onClick={handleOnclick}
                disabled={loader === true}
                className={`  text-center w-full cursor-pointer`}
              >
                <div className="flex justify-center">
                
                {loader && (<Loader />)}{ButtonText}
                </div>
              </a>
            </div>
          )}
          {!!ButtonText2 && (
          <div className=" w-full">
          <a
                aria-label="button"
                type="button"
                href={handleModalSubmit2}
                onClick={handleResentCashPin}
                disabled={loader === true}
                className={` text-center w-full cursor-pointer hover:bg-border_lightest rounded-full py-3 `}
              >
                <div className="flex justify-center">
                
                {ButtonText2}
                </div>
              </a>
          </div>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default Modal